import { render, staticRenderFns } from "./ShortAnswer.vue?vue&type=template&id=b7bc418e&scoped=true&"
import script from "./ShortAnswer.vue?vue&type=script&lang=js&"
export * from "./ShortAnswer.vue?vue&type=script&lang=js&"
import style0 from "./ShortAnswer.vue?vue&type=style&index=0&id=b7bc418e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7bc418e",
  null
  
)

export default component.exports